import { useEffect, useState } from "react";
import PaymentService from '../../services/paymentService';

const useBanks = (country) => {
    const [searchResults, setSearchResults] = useState({
        banks: [],
        totalResults: 0,
        totalPage: 0
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = async () => {
            setLoading(true);
            PaymentService
                .GetBanks(100, 1, { country })
                .then(res => setSearchResults({
                    banks: res.values.filter(e => e.active === true),
                    totalResults: res.totalResults,
                    totalPage: res.totalPage
                }))
                .finally(() => setLoading(false))
        }
        if (!loading && !!country)
            getFromServer();
    }, [country]); // eslint-disable-line react-hooks/exhaustive-deps

    return {
        ...searchResults,
        loading
    }
}
export default useBanks;